import { FC, SVGProps } from "react";

const DeleteIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
      stroke="currentcolor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M1 4.5H15M5.5 4.5V2.5C5.5 2.22386 5.72386 2 6 2H10C10.2761 2 10.5 2.22386 10.5 2.5V4.5M12.5 4.5V15.5C12.5 15.7761 12.2761 16 12 16H4C3.72386 16 3.5 15.7761 3.5 15.5V4.5" />
    </svg>
  );
};

export default DeleteIcon;
